module.exports = __webpack_public_path__ + "static/media/connect.6c6c0da1.svg";